import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';

import { Button, Container, DisplayText, TitleText } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';
import { useTelemetry, useTrackEventEffect } from '@order/Telemetry';

import { NotFoundScreen } from '../NotFoundScreen';

export const HsaFsaScreen = () => {
  const isFlexEnabled = useFeatureFlag('CELS-5522-flex-enabled');

  const { track } = useTelemetry();

  useTrackEventEffect({ name: 'hsafsa.landing_page.viewed', skip: !isFlexEnabled });

  const checkEligibility = useCallback(() => {
    track('hsafsa.landing_page.cta_tapped');
  }, [track]);

  if (!isFlexEnabled) {
    return <NotFoundScreen />;
  }

  return (
    <Container style={styles.container}>
      <DisplayText>Coming soon</DisplayText>
      <TitleText>HSA/FSA</TitleText>

      <Button onPress={checkEligibility}>Check eligibility</Button>
    </Container>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingVertical: 64,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
